module.exports = __webpack_public_path__ + "img/ic-list-plus.0288022f.svg";